import { IndexRouteView } from './view';

export const indexRoute = {
  index: true,
  element: <IndexRouteView/>,
};
